module.exports = __webpack_public_path__ + "static/img/clickin.b047a407.gif";